import * as React from "react";
import {
  BalanceUpdateInstantTournamentPurchaseDetailsFragment,
} from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";

export const BalanceUpdateInstantTournamentPurchaseDetails = ({
                                                      details,
                                                    }: {
  details: BalanceUpdateInstantTournamentPurchaseDetailsFragment;
}) => {
  return (
    <Trans i18nKey="transaction.BalanceUpdateTournamentPurchaseDetails_details">
      Purchased tournament entry <strong>{{ name: details.tournamentName }}</strong>
    </Trans>
  );
};
